import Cross from "./Cross";
import Rules from "./Rules";
export default function Modal(props){
    return(
        <section className=" bg-[#FFFFFF] text-[#3E425B] rounded-xl   absolute top-50 left-50 right-50 bottom-50 px-4 py-4">
            <div className=" flex justify-between items-center my-2 mx-2">
                <h2 className=" text-3xl font-bold tracking-wide">RULES</h2>
                <div onClick={props.click}>
                <Cross />
                </div>
            </div>
            <Rules />
        </section>
    )
}